import React, { useEffect, useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import GoodTypeSelectMain from '../../../../form/fields/GoodTypeSelectMain'
import GoodSelectMain from '../../../../form/fields/GoodSelectMain'
import { addSeriesesInPackAPI } from '../../../../../api/pack/seriesAPI'
import { responseError } from '../../../../../helpers/response/ResponseHelper'

const BoxSeriesForm = ({ packId, boxBd, setOpen }) => {

	const [data, setData] = useState({}) // Дані з форми

	const [valid, setValid] = useState({}) // Валідація кожного поля
	const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState('')

	useEffect(() => {
		checkValid(valid, setIsValidForm)
	}, [valid])

	const add = () => {
		setLoading(true)
		setError('')
		addSeriesesInPackAPI({ 
			packId, 
			goodTypeId: data.goodTypeId,
			goodId: data.goodId
		}).then(data => {
			setOpen(false)
			setLoading(false)
		}).catch(e => {
			setError(responseError(e))
			setLoading(false)
		})
	}

  return (
    <div className='myFormSimple'>
		<div>
			<p>Будьте уважні, що цей товар буде доданий в кількості штук, що дорівнює кількості дронів в партії й автоматично розфасується по коробкам</p>
			<p>Якщо треба додати товари поштучно, то необхідно зайти в необхідну коробку й додати товар в неї</p>
		</div>

		{
			formDataProductIsField('goodTypeId', 'boxSeriesInPack') ?
				<GoodTypeSelectMain
					required={formDataProductRequiredField('goodTypeId', 'boxSeriesInPack')}
					setValidate={e => updateValidate(setValid, 'goodTypeId', e)}
					setValueForm={e => setValueForm(setData, 'goodTypeId', e)}
					forciblyValue={data && data.goodTypeId ? data.goodTypeId : ''}
				/>
			: ''
        }
		{
			formDataProductIsField('goodId', 'boxSeriesInPack') ?
				<GoodSelectMain
					goodTypeId={data && data.goodTypeId ? data.goodTypeId : null}
					required={formDataProductRequiredField('goodId', 'boxSeriesInPack')}
					setValidate={e => updateValidate(setValid, 'goodId', e)}
					setValueForm={e => setValueForm(setData, 'goodId', e)}
					forciblyValue={data && data.goodId ? data.goodId : ''}
				/>
			: ''
        }

        {
			error ?
				<div className='error'>
					{ error }
				</div>
			: ''
		}

        <MyButton
            size='md'
            onClick={add}
            disabled={!isValidForm || loading ? true : false}
        >
            Додати товари
        </MyButton>
    </div>
  )
}

export default BoxSeriesForm